<script setup>
import {computed, getCurrentInstance, onMounted, reactive, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import LoadingIcon from "@/components/LoadingIcon.vue";
import Paginate from "vuejs-paginate-next"
import {
  accessControlApi,
  futured_medias_Api
} from "@/api/forwriting_index";
import {datePipe} from "@/utils/datatimeUtils";
import CheckPointLimit from "@/views/forwriting/fw00_check_point_limit.vue"

const instance = getCurrentInstance()
const t = instance.proxy.$t
const valid_types = ['image/png', 'image/jpeg']

const route = useRoute()
const router = useRouter()
const article_list = reactive({
  id: route.params.article_list_id
})

// ==== modal_new ====

const modal_new = reactive({
  show: false,
  image_url: null,
  file: null,
  futured_media: {
    "article_list_id": article_list.id,
    "file_name": "",
    "blob_storage_path": "",
  },
})
const open_modal_new = () => {
  alert(t("Futured_medias.feature_disabled"))
}
// for select file
const on_file_change = async( e) => {
  modal_new.file = e.target.files[0]
  modal_new.futured_media.file_name = modal_new.file.name
  console.log( "* file_name:", modal_new.futured_media.file_name)

  if( valid_types.includes( modal_new.file.type) ) {
    // 創建圖片的本地 URL 並存儲到 image_url
    modal_new.image_url = URL.createObjectURL( modal_new.file)
    // console.log( "* image_url:", modal_new.image_url)
  }
}
// for drag file
const onDragOver = () => {
  // 可在此自定義拖拽區域的樣式
}
const onFileDrop = (event) => {
  const files = event.dataTransfer.files
  if (files.length === 0) return

  modal_new.file = files[0]
  modal_new.futured_media.file_name = modal_new.file.name
  console.log( "modal_new.file.name:", modal_new.file.name)

  if( valid_types.includes( modal_new.file.type) )
  {
    // 創建圖片的本地 URL 並存儲到 image_url
    modal_new.image_url = URL.createObjectURL( modal_new.file)
    // console.log( "* image_url:", modal_new.image_url)
  }
}
const modal_new_create = async () => {
  alert(t("Futured_medias.feature_disabled"))
  modal_new.show = false
}

// ==== modal_update ====
// todo: 瀏覽器會使用緩存圖片，導致顯示不正確
// 2. 利用 HTTP 頭設置 Cache-Control
// 在伺服器端設置適當的 HTTP 頭以控制緩存行為。這需要伺服器的支援：
//
// 禁止緩存：(yaml)
// Cache-Control: no-cache, no-store, must-revalidate
// Pragma: no-cache
// Expires: 0

// 例如，在 Apache 中可以在 .htaccess 文件中設置：
// <FilesMatch "\.(html|css|js|png|jpg|jpeg|gif|ico)$">
//   Header set Cache-Control "no-cache, no-store, must-revalidate"
//   Header set Pragma "no-cache"
//   Header set Expires 0
// </FilesMatch>

const modal_update = reactive({
  show: false,
  image_url: null,
  file: new File([], 'empty.jpg', { type: 'image/png'}),
  futured_media: {
    "article_list_id": article_list.id,
    "file_name": "",
    "blob_storage_path": "",
  },
  id: -1
})
const handleEdit = async ( par_id) => {
  console.log( "handleEdit() -> par_id:", par_id)
  modal_update.id = par_id

  const resp = await futured_medias_Api.get_1( par_id)

  // 這個路徑用於顯示
  modal_update.image_url                       = resp.data.blob_storage_path

  modal_update.id                              = resp.data.id
  modal_update.futured_media.file_name         = resp.data.file_name
  modal_update.futured_media.blob_storage_path = resp.data.blob_storage_path

  modal_update.show = true
}
const on_file_change_update = async( e) => {
  console.log( "*** on_file_change_update()...")
  modal_update.file = e.target.files[0]
  // modal_update.futured_media.file_name = modal_update.file.name
  console.log( "file_name(on_file_change_update):", modal_update.futured_media.file_name)

  if( valid_types.includes( modal_update.file.type) ) {
    modal_update.image_url = URL.createObjectURL( modal_update.file)
  }
}
const onDragOver_update = () => {
  // 可在此自定義拖拽區域的樣式
}
const onFileDrop_update = (event) => {
  console.log( "**** onFileDrop_update()...")
  const files = event.dataTransfer.files
  if (files.length === 0) return

  modal_update.file = files[0]
  // modal_update.futured_media.file_name = modal_update.file.name

  // 檢查是否是 PNG 文件
  if( valid_types.includes( modal_update.file.type) ) {
    modal_update.image_url = URL.createObjectURL( modal_update.file)
  }
}
const handleEdit_confirm = async ( ) => {
  isLoading.show = true;

  const formData = new FormData()
  formData.append( "file",            modal_update.file)
  formData.append( "article_list_id",   modal_update.futured_media.article_list_id)
  formData.append( "blob_storage_path", modal_update.futured_media.blob_storage_path)
  formData.append( "file_name",         modal_update.futured_media.file_name)

  const resp = await futured_medias_Api.update( modal_update.id, formData)
  if( resp.status !== 200) {
    isLoading.show = false;
    throw new Error("ERROR");
  }

  isLoading.show = false;
  modal_update.show = false

  await reload_data()
  window.location.reload();
}

// ==== modal_del_1 ====

const modal_del_1 = reactive({
  show: false,
  msg: "",
  id: -1,
})
const handleDelete = async ( par_id, par_name) => {
  console.log( "par_name:", par_name)
  modal_del_1.msg = t('Futured_medias.delete_prompt'
  ).replace( "name", par_name)
  modal_del_1.id = par_id
  modal_del_1.show = true;
};
const handleDelete_confirm = async () => {
  isLoading.show = true;

  try {
    const resp = await futured_medias_Api.delete( modal_del_1.id );
    if( resp.status !== 200) {
      isLoading.show = false;
      throw new Error("ERROR");
    }

    data.items = data.items.filter( ( item) => item.id !== modal_del_1.id);

    isLoading.show = false;
    modal_del_1.show = false;
  } catch (error) {
    isLoading.show = false;
    console.error("刪除未來媒體失敗:", error);
    console.error("錯誤詳情:", {
      message: error.message,
      response: error.response,
      config: error.config
    });
    
    // 提取後端返回的友好錯誤消息（支持日文|中文格式）
    let errorMessage = 'Network Error';
    if (error.response && error.response.data) {
      if (error.response.data.detail) {
        const detail = error.response.data.detail;
        // 檢查是否為「日文|中文」格式
        if (detail.includes('|')) {
          const [jaMsg, twMsg] = detail.split('|');
          // 根據當前語言選擇對應的訊息
          const currentLocale = instance.proxy.$i18n.locale.value || 'ja';
          errorMessage = currentLocale === 'tw' ? twMsg.trim() : jaMsg.trim();
        } else {
          errorMessage = detail;
        }
      } else if (error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (typeof error.response.data === 'string') {
        errorMessage = error.response.data;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    alert(`刪除失敗: ${errorMessage}`);
  }
};

// ==== modal_del_selected ====

const modal_del_selected = reactive({
  show: false,
  msg: "",
  ids: [],
})
const del_selected = async () => {
  modal_del_selected.ids = []
  for (const i in checked.items)
    if( checked.items[i])
      modal_del_selected.ids.push( i)

  modal_del_selected.msg = t('Futured_medias.delete_prompt_much'
  ).replace( "num", modal_del_selected.ids.length)
  modal_del_selected.show = true
}
const del_selected_confirm = async () => {
  isLoading.show = true
  for( const i in modal_del_selected.ids)
  {
    const id = modal_del_selected.ids[i]
    const resp = await futured_medias_Api.delete( id );
    if( resp.status !== 200) {
      isLoading.show = false;
      throw new Error("ERROR");
    }
  }
  await reload_data()
  isLoading.show = false

  modal_del_selected.show = false
}

// ==== filter ====

const filter = reactive({
  temp: "",
  searchKey: null,
});
const handleFilter = () => {
  filter.searchKey = filter.temp
  page.current = 1
};
const filteredData = computed(() => {
  let temp = data.items || [];
  if( filter.searchKey)
  {
    const str_filter = filter.searchKey.toLowerCase()
    temp = temp.filter( ( item) =>
        String( item.file_name).toLowerCase().indexOf( str_filter) > -1
    )
  }
  return temp;
});

// ==== paging ====

const page = reactive({
  current: 1,
  num: 10,
})
const page_count = computed(() => {
  let cc = Math.floor( filteredData.value.length / page.num)
  if( filteredData.value.length % page.num === 0)
    return cc
  return cc + 1
})

// ==== init data... ====

const data = reactive({
  items: [],
})
const reload_data = async( ) => {
  const resp = await futured_medias_Api.getAll_filter( article_list.id)
  data.items = resp.data;

  for( let i in data.items) {
    const id = data.items[i].id
    checked.items[ id] = false
  }
}
onMounted(async () => {
  if( ! await accessControlApi.check_option_access()) {
    await router.push(`/forwriting/options_error`)
    return
  }

  await reload_data()

  // check the point_limit
  point_limit.is_over = await ref_CheckPointLimit.value.check()
});

// ==== checked/un-checked ====

const checked = reactive({
  items: {}
})
const onSelectAllChange = async( e) => {
  const checked_val = e.target.checked
  for( const i in checked.items)
    checked.items[i] = checked_val
  // console.log( "checked_items:", checked.items)
}

// ==== button refresh ====

const refreshPage = async () => {
  await reload_data()
  window.location.reload();
}

// ==== isLoading ====

const isLoading = reactive({
  show: false
})

// ==== modal_over_points ====
const ref_CheckPointLimit = ref(null)
const point_limit = reactive({
  is_over: false,
})

</script>

<template>

  <!-- isLoading -->
  <LoadingIcon :is-loading="isLoading.show"></LoadingIcon>

  <!-- modal_over_points -->
  <CheckPointLimit ref="ref_CheckPointLimit"></CheckPointLimit>

  <!-- Modal_new" -->
  <div v-if="modal_new.show" class="modal-create">
    <div class="modal-content">

      <div class="row" >
        <h4>{{ $t( "Futured_medias.image_upload") }}</h4>
      </div>

      <div class="row" style="margin-top: 20px">

        <div class="drop-area"
            @dragover.prevent="onDragOver"
            @drop.prevent="onFileDrop"
        >
          <!-- 顯示預覽的圖片 -->
          <img v-if="modal_new.image_url"
               :src="modal_new.image_url"
               alt="Dropped Image" class="preview" />

          <!-- 如果還沒有圖片，顯示提示 -->
          <div v-else>
            <p>{{ $t( "Futured_medias.drag_image") }}</p>
            <p>{{ $t( "Futured_medias.or") }}</p>
          </div>

        </div>

      </div>

      <div class="row">
        <label for="fileInput" class="upload-label">
          {{ $t( "Futured_medias.select_file") }}</label>
        <input type="file"
            id="fileInput"
            accept="image/*"
            @change="on_file_change"
            hidden
        />
<!--        <input type="file" class="form-input"-->
<!--               @change="on_file_change"/>-->
      </div>

      <!-- button -->
      <div class="row" style="margin-top: 20px">
        <button class="btn btn-primary"
                style="width: 120px; margin-left: 20px"
                @click="modal_new_create">
          {{ $t( "Futured_medias.append_2") }}</button>

        <button class="btn btn-primary" style="width: 120px; margin-left: 20px"
                @click="modal_new.show=false">
          {{ $t( "Futured_medias.return") }}</button>
      </div>

    </div>
  </div>
  <!-- end of Modal_new" -->

  <!-- Modal_update" -->
  <div v-if="modal_update.show" class="modal-create">
    <div class="modal-content">

      <div class="row" >
        <h4>{{ $t( "Futured_medias.image_edit") }}</h4>
      </div>

      <div class="row" style="margin-top: 30px">
        <label>{{ $t( "Futured_medias.file_name") }}:</label>
        <input type="text" style="margin-left: 10px; width: 600px"
               v-model="modal_update.futured_media.file_name"/>
      </div>

      <div class="row" style="margin-top: 20px">

        <label>{{ $t( "Futured_medias.image") }}:</label>
        <div class="drop-area"
             @dragover.prevent="onDragOver_update"
             @drop.prevent="onFileDrop_update">
          <!-- 顯示預覽的圖片 -->
          <img v-if="modal_update.image_url"
               :src="modal_update.image_url"
               alt="Dropped Image" class="preview" />
          <!-- 如果還沒有圖片，顯示提示 -->
          <div v-else>
            <p>{{ $t( "Futured_medias.drag_image") }}</p>
            <p>{{ $t( "Futured_medias.or") }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <label for="fileInput2" class="upload-label">
          {{ $t( "Futured_medias.select_file") }}</label>
        <input type="file"
               id="fileInput2"
               accept="image/*"
               @change="on_file_change_update"
               hidden
        />

<!--        <input id="fileInput" type="file" class="form-input"-->
<!--               @change="on_file_change_update"-->
<!--        />-->
      </div>

      <!-- 2 buttons-->
      <div class="row" style="margin-top: 20px">
        <button class="btn btn-primary"
                style="width: 120px; margin-left: 20px"
                @click="handleEdit_confirm">
          {{ $t( "Futured_medias.update") }}</button>

        <button class="btn btn-primary" style="width: 120px; margin-left: 20px"
                @click="modal_update.show=false">
          {{ $t( "Futured_medias.return") }}</button>
      </div>

    </div>
  </div>
  <!-- end of Modal_new" -->

  <!-- modal_del_selected -->
  <div v-if="modal_del_selected.show" class="modal-del">
    <div class="modal-content">

      <div class="row" style="margin-top: 20px;text-align: center">
        <p>{{ modal_del_selected.msg }}</p>
      </div>

      <!-- 2 buttons -->

      <div class="row" style="margin-top: 20px;margin-left: 10px; margin-right: 10px">
        <button class="btn btn-primary"
                @click="del_selected_confirm">
          {{ $t( "Futured_medias.OK") }}</button>
      </div>

      <div class="row" style="margin-top: 20px;margin-left: 10px; margin-right: 10px">
        <button class="btn btn-primary"
                @click="modal_del_selected.show = false">
          {{ $t( "Futured_medias.cancel") }}</button>
      </div>

    </div>
  </div>
  <!-- end of modal_del_selected -->

  <!-- modal_del_1 -->
  <div v-if="modal_del_1.show" class="modal-del">
    <div class="modal-content">

      <div class="row" style="margin-top: 20px;text-align: center">
        <p>{{ modal_del_1.msg }}</p>
      </div>

      <!-- 2 buttons -->
      <div class="row" style="margin-top: 20px;margin-left: 10px; margin-right: 10px">
        <button class="btn btn-primary"
                @click="handleDelete_confirm">
          {{ $t( "Futured_medias.OK") }}</button>
      </div>

      <div class="row" style="margin-top: 20px;margin-left: 10px; margin-right: 10px">
        <button class="btn btn-primary"
                @click="modal_del_1.show = false">
          {{ $t( "Futured_medias.cancel") }}</button>
      </div>

    </div>
  </div>
  <!-- end of Modal_delete -->

  <div class="container">

    <!-- title-->
    <div class="row">
      <h4>{{ $t( "Futured_medias.title") }}</h4>
    </div>

    <!-- key for filer(關鍵詞過濾) -->
    <div class="row">
      <div class="column">

        <label for="search-keyword">{{ $t( "Futured_medias.search_keyword") }}:</label>
        <input type="text" id="search-keyword" v-model="filter.temp"
               style="padding: 0 10px; margin: 10px;"/>

        <button class="btn btn-primary" @click="handleFilter"
                style="padding: 0 50px; margin: 10px;">
          {{ $t( "Futured_medias.filter") }}</button>
      </div>

    </div>

    <!-- 3 button -->
    <div class="row">
      <div class="column" style="text-align: right">

        <button class="btn btn-primary"
                @click="open_modal_new"
                style="padding: 0 50px; margin: 10px;">
          + {{ $t( "Futured_medias.append") }}</button>

        <button class="btn btn-primary"
                @click="del_selected"
                style="padding: 0 50px; margin: 10px;">
          {{ $t( "Futured_medias.delete_much") }}</button>

        <button class="btn btn-primary" @click="refreshPage"
                style="padding: 0 50px; margin: 10px;">
          {{ $t( "Futured_medias.refresh") }}
        </button>

      </div>
    </div>

    <!-- select/de-select -->
    <div class="row">
      <div class="column">
        <input id="select_all" type="checkbox" @change="onSelectAllChange"/>
        <label style="padding: 0 10px; margin: 1px;" for="select_all">
          {{ $t( "Futured_medias.select_all") }}</label>
      </div>
    </div>

    <div class="row">

      <!-- the main table(主體表格) -->
      <table class="table table-hover">

        <thead>
        <tr>
          <th scope="col">{{ $t( "Futured_medias.selected") }}</th>

          <th scope="col">{{ $t( "Futured_medias.image") }}</th>
          <th scope="col">{{ $t( "Futured_medias.file_name") }}</th>

          <th scope="col">{{ $t( "Futured_medias.author") }}</th>
          <th scope="col">{{ $t( "Futured_medias.operation") }}</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(item, index) in filteredData" :key="item.id"
            v-show="( Math.floor( index / page.num) + 1) === page.current"
            style="vertical-align: center">

          <td><input type="checkbox" v-model="checked.items[ item.id]"></td>

<!--          <td><img :src="item.blob_storage_path"-->
<!--                   style="width: 160px; height: 120px"  alt=""/></td>-->

          <!-- ?t='+Date.now() 強迫刷新，避免使用組存圖片；但在 update 畫面不適用-->
          <td><img :src="item.blob_storage_path+'?t='+Date.now()"
                   style="width: 160px; height: 120px"  alt=""/></td>
          <td>{{item.file_name}}</td>

          <td>{{ datePipe(item.created_at, format = 'yyyy/MM/dd')}}</td>

          <td>
            <button class="btn btn-primary" style="padding: 0 20px"
                    @click="handleEdit( item.id)">
              {{ $t( "Futured_medias.edit") }}</button>

            <button class="btn btn-danger" style="padding: 0 20px; margin-top: 1px;margin-left: 10px"
                    @click="handleDelete( item.id, item.file_name)">
              {{ $t( "Futured_medias.delete") }}</button>
          </td>

        </tr>
        </tbody>
      </table>

    </div>
    <div class="row">
      <paginate style="margin-left: 300px; cursor: pointer;"
                v-model="page.current"

                :page-count="page_count"
                :page-range="3"
                :margin-pages="2"

                :prev-text="'<'"
                :next-text="'>'"
      >
      </paginate>
    </div>
  </div>

</template>

<style scoped>

.upload-label {
  display: inline-block;
  margin-left: 450px;
  margin-top: 10px;
  padding: 8px 16px;
  background-color: rgb(211,211,211);
  color: black;
  border-radius: 5px;
  cursor: pointer;
  width: 160px;
  text-align: center;
}

.drop-area {
  margin-left: 10px;
  width: 600px;
  height: 320px;
  display: flex;
  background-color: lightgrey;
  justify-content: center;
  align-items: center;
  text-align: center;
  vertical-align: bottom;
}

.form-input {
  width: 600px;
  margin-left: 10px;
  font-size: 16px;
  background-color: lightgrey;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.preview {
  max-width: 100%;
  max-height: 100%;
}

.tr-line {
  height: 50px;
}

.td-left {
  text-align: right;
  width: 150px;
}

.td-right {
  text-align: left;
  width: 720px;
  //margin-right: 20px;
}

.td-combo {
  margin-top: 10px;
  margin-left: 10px;
  width: 320px;
}

.td-text {
  padding: 0 10px;
  margin: 10px;
  width: 720px;
}

.modal-del {
  height: 800px;
  max-height: 1024px;
  width: 480px;

  display: flex;
  justify-content: center;
  align-items: center;

  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1000; /* 他の要素より前面に */

  top: 100px;
  left: 100px;
  position: absolute;
  padding: 20px;
}

.modal-create {
  height: 960px;
  max-height: 1280px;
  width: 960px;

  display: flex;
  justify-content: center;
  align-items: center;

  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1000; /* 他の要素より前面に */

  top: 100px;
  left: 100px;
  position: absolute;
  padding: 20px;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  max-width: 1600px;  /* お好みに合わせて変更 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.custom-cell {
  text-align: center;
  padding: 0 20px;
  color: white;
  //background-color: rgb( 197, 197, 197); /* 設定背景色 */
  border-radius: 10px; /* 設定圓角半徑 */
  width: 100px;
}

.tags {
  position: relative;
  float: left;
  color: #000000;
  line-height: 28px;

  margin-left: 10px;
  margin-top: 30px;
  margin-bottom: 1px;
  //margin: 0 4px 4px 0;
  padding: 0 22px 0 10px;
}

.tags .content {
  line-height: 28px;
}

.tags .del {
  width: 22px;
  height: 28px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: -1px;
  right: 0;
}

.tags {
  background-color: #e0e0e0;
  border: 1px solid rgb(54, 54, 54);
  cursor: default;
}

</style>